import Footer from "../../components/Footer";
import TopHeader from "../../components/TopHeader";

const Cgu = () => {
  return (
    <>
      <TopHeader btn={true} />
      <div className="container mt-40 mb-80">
        <div className="col-md-8 mx-auto">
          <h2 className="grey500">
            Conditions Générales d’Utilisation – C.G.U.
          </h2>
          <p className="body mt-14 grey66 bold500">
            <p>Dernière mise à jour : 16/06/2025</p>
          </p>
          <h4 className="grey500 mt-24">PRÉAMBULE</h4>
          <p className="body mt-16 grey66 bold500">
          Le site Web TWYNY (et l’application TWYNY) est un service digital en ligne de
            réservation de services (ci-après la « Plateforme » ou le « Site »), édité et exploité
            par la société Eppox SAS, société de droit français au capital de 50 000 €, ayant son
            siège social au 78, Av. des Champs-Elysées, Bureau 326, 75008 Paris, France et
            immatriculée au RCS Paris le numéro 878115856 (la « Société » ou « TWYNY »).
          </p>
          <p className="body mt-16 grey66 bold500">
          La Société propose aux utilisateurs de la Plateforme (les « Utilisateurs ») un service
digital de mise en relation entre les Utilisateurs souhaitant rechercher et réserver un
service et des prestataires professionnels qualifiés proposant et encadrant des
services de ce type (les « Partenaires ») (le « Service »).
          </p>
          <p className="body mt-16 grey66 bold500">
          La Plateforme a uniquement pour objet de mettre en relation les clients potentiels et
les Partenaires, ces derniers utilisant le Service digital et fournissant leurs prestations
en toute indépendance et sous leur propre et seule responsabilité. La Société
n’intervient en aucune façon dans la relation contractuelle qui se forme entre le
Partenaire et le Client lors de chaque réservation confirmée.
          </p>
          <h4 className="grey500 mt-24">CONDITIONS GÉNÉRALES D’UTILISATION</h4>
          <p className="body mt-16 grey66 bold500">
          Les présentes conditions générales d’utilisation (ci-après les &quot;Conditions Générales&quot;
ou les « CGU ») définissent les termes et les conditions régissant l’utilisation du
Service digital offert par TWYNY.
          </p>
          <p className="body mt-16 grey66 bold500">
          Les présentes CGU couvrent uniquement l’utilisation de la Plateforme et la
réservation des services et services digitaux sur la Plateforme par l’Utilisateur, mais
ne s’appliquent pas à l’exécution de ces mêmes services et services digitaux par les
Partenaires.
          </p>
          <p className="body mt-16 grey66 bold500">
          TWYNY se réserve le droit de modifier les présentes CGU à tout moment, sans
préavis, étant convenu que de telles modifications ne seront pas applicables dans le
cas d’une réservation qui aurait déjà été confirmée par un Partenaire. Ainsi, les CGU,
pouvant être mises à jour et modifiées à tout moment, doivent être consultées
régulièrement et s’appliquent dès leur actualisation à toute nouvelle utilisation du
Service digital.
          </p>
          <h4 className="grey500 mt-24">IMPORTANT :</h4>
          <p className="body mt-16 grey66 bold500">
          L’Utilisateur reconnaît et accepte que toute navigation sur le Site, ainsi que toute
utilisation des fonctionnalités et services offerts par ou sur ce Site, et en particulier la
réservation d’un service via le Service digital, impliquent l’acceptation expresse et
préalable des présentes Conditions Générales. Si l’Utilisateur n’accepte pas tout ou
partie de ces Conditions Générales, l’Utilisateur n’est pas autorisé à se maintenir sur
le Site et n’est pas autorisé à utiliser le Service digital.
          </p>

          <h4 className="grey500 mt-24">ARTICLE 1 — DÉFINITIONS</h4>
          <p className="body mt-16 grey66 bold500">
          Dans les présentes, les termes et expressions identifiés par une majuscule ont la
signification indiquée ci-après, qu’ils soient employés au singulier ou au pluriel.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Service » : désigne le service proposé à la réservation par un Partenaire sur le Site
          et le cas échéant commandée par un Client via le Service digital.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Application » : désigne les applications TWYNY Iphone et Android de la Société,
en ce compris, le cas échéant, les mises à jour et nouvelles versions de celles-ci.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Client » : désigne un Utilisateur, disposant d’un compte client, ayant conclu un
          Contrat avec un Partenaire.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Conditions Générales » : désigne le présent document, tel que pouvant être
          amendé conformément aux stipulations de l’article « Modifications » des présentes.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Contenu » : désigne les informations, textes, photographies, commentaires, et tous
autres éléments que l’Utilisateur est susceptible de communiquer à la Société ou de
saisir directement sur le Site dans le cadre de l’outil d’évaluation des Partenaires.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Contrat » : désigne le contrat qui se forme entre le Partenaire et le Client par la
commande sur le Site par le Client d’un Service auprès du Partenaire, dans les
conditions décrites à l’article « Réservation et paiement ».
          </p>
          <p className="body mt-16 grey66 bold500">
          « Magasin d’Applications » : désigne la plateforme de téléchargement d’applications,
telles que l’App Store d’Apple ou l’Android Market de Google, par le biais de laquelle
l’Utilisateur a téléchargé l’Application.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Partenaire » : désigne la personne, physique ou morale, qui utilise le Site pour
          proposer des Services aux Utilisateurs / Clients.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Plateforme » : désigne le site accessible via la connexion sur le site Internet
TWYNY ou via le téléchargement de l’Application.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Service digital » : désigne le service technique de mise en relation des
          Utilisateurs/Clients avec les Partenaires tel que décrit au Préambule des présentes.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Site » : désigne le site accessible via la connexion sur le site Internet TWYNY ou
          via le téléchargement de l’Application.
          </p>
          <p className="body mt-16 grey66 bold500">
          « Utilisateur » : désigne toute personne physique naviguant sur le Site.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 2 — DESCRIPTION DU SERVICE</h4>
          <p className="body mt-16 grey66 bold500">
          La Société propose, via la Plateforme, un service digital de mise en relation au
bénéfice des Utilisateurs, Clients et Partenaires. Ce service digital inclue la gestion
des réservations, des paiements, des annulations/remboursements (pour le compte
des Partenaires) ainsi qu'une assistance de premier niveau pour les Utilisateurs et
les Clients comme détaillé dans l'''article 13 des Conditions Générales.
          </p>
          <p className="body mt-16 grey66 bold500">
          Par le biais de la Plateforme et du Service digital l’Utilisateur peut ainsi réserver un
          service auprès d’un Partenaire.
          </p>
          <p className="body mt-16 grey66 bold500">
          Le Contrat qui se forme entre le Partenaire et le Client via le Site est un contrat
autonome, dans lequel la Société n’assume aucune responsabilité. Le Contrat est
réputé formé dès lors qu’un Partenaire a accepté la demande de réservation d’un
Client.
          </p>
          <p className="body mt-16 grey66 bold500">
          Il appartient en conséquence à tout Utilisateur de vérifier qu’il souhaite effectivement
s’engager en toute indépendance dans une relation contractuelle avec un Partenaire,
et qu’il est dans ce cadre prêt à en assumer toutes les conséquences, le nom du
Partenaire étant en tout occasion présentée de manière transparente sur le Site.
          </p>
          <p className="body mt-16 grey66 bold500">
          Le Partenaire est seul responsable vis-à-vis du Client de l’exécution des prestations
prévues au Contrat, la Société n’assumant aucune responsabilité à ce titre. De la
même façon la Société n’est en aucune façon responsable ni du comportement du
Client vis-à-vis du Partenaire.
          </p>
          <h4 className="grey500 mt-24">
            ARTICLE 3 — ACCÈS AU SERVICE ET GESTION DES IDENTIFIANTS
          </h4>
          <p className="body mt-16 grey66 bold500">
          L’Utilisateur fait son affaire personnelle de la mise en place des moyens
informatiques et de télécommunications permettant l'accès au Site et des
connaissances nécessaires à l'utilisation d'Internet et à l'accès et l’utilisation du Site.
L’Utilisateur conserve à sa charge les frais de connexion et d'équipement liés à
l'accès à Internet ainsi qu’à l'utilisation du Site et du Service.
          </p>
          <p className="body mt-16 grey66 bold500">
          L’Utilisateur qui souhaite réserver un Service doit créer un compte Utilisateur ou se
connecter à son compte si celui-ci est déjà créé. L’accès à ce compte se fait par le
biais de l’utilisation d’un identifiant et d’un mot de passe.
          </p>
          <p className="body mt-16 grey66 bold500">
          L’Utilisateur s’engage à communiquer des informations exactes lors de l’inscription
sur le Site.
          </p>
          <p className="body mt-16 grey66 bold500">
          L’Utilisateur s’engage également à mettre à jour ses informations en cas de
modification.
          </p>
          <p className="body mt-16 grey66 bold500">
          L’Utilisateur est seul responsable du maintien de la confidentialité de ses identifiants
          et mots de passe.
          </p>
          <p className="body mt-16 grey66 bold500">
          Il lui appartient de mettre en œuvre les mesures de précaution et de sécurité
          nécessaires à la protection de son mot de passe en particulier.
          </p>
          <p className="body mt-16 grey66 bold500">
          L’Utilisateur doit immédiatement prendre toutes mesures adéquates en cas de
divulgation de son mot de passe et/ou de toute utilisation frauduleuse de celui-ci. Il
doit notamment immédiatement changer son mot de passe.
          </p>
          <p className="body mt-16 grey66 bold500">
          L’Utilisateur est seul responsable de l’utilisation qui peut être faite de son identifiant
et de son mot de passe. Tout accès au compte Utilisateur au moyen de l’identifiant et
du mot de passe susvisés sera réputé, de façon irréfragable, avoir été effectué par
l’Utilisateur, de même que toute modification ou opération réalisée sur le compte
Utilisateur à la suite de la saisie dudit identifiant et mot de passe.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 4 — RÉSERVATION ET PAIEMENT</h4>
          <h5 className="grey500 mt-16 ">
            4.1 Modalités de réservation d’un Service
          </h5>
          <p className="body mt-16 grey66 bold500">
          Le Client réserve le Service auprès du Partenaire au travers du Service digital.
          </p>
          <h5 className="grey500 mt-16 ">Processus de réservation</h5>
          <p className="body mt-16 grey66 bold500">
          Si aucun contrôle de disponibilité n'est nécessaire, ou si le Partenaire utilise le
logiciel extranet TWYNY de gestion de réservations auquel TWYNY est connecté ou
un logiciel tiers auquel TWYNY est connecté et qui permet la transmission de ses
disponibilités sur la Plateforme en temps réel, l'utilisateur de la Plateforme peut
réserver directement le Service et payer par carte de crédit ou tout autre moyen de
paiement accepté par le biais de la Plateforme, et ainsi conclure la Transaction.
          </p>
          <p className="body mt-16 grey66 bold500">
          Si la réservation d’un Service par un Client auprès d’un Partenaire sur la Plateforme
          se fait avec un contrôle de disponibilité :
          </p>
          <ul className="mt-40">
            <p className="body mt-16 grey66 bold50">
              <li>
              le Client soumet une demande de réservation de Service en ligne auprès d’un
Partenaire. Il communique dans ce cadre un certain nombre d’informations au
Partenaire ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              le Client rentre ses coordonnées bancaires ou carte de crédit afin de
              permettre le paiement au travers d’un système de paiement sécurisé ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              le Partenaire est informé automatiquement de la demande de réservation (par
e-mail, sms, téléphone, ou sur l’extranet mis à sa disposition), et dispose d’un
délai maximum de 48 heures pour communiquer son acceptation ou son refus
de la demande de réservation ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              si la demande de réservation est acceptée, le Contrat entre le Client et le
Partenaire est automatiquement conclu. Le Client en est informé dans les plus
brefs délais ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              si la demande est rejetée, un remboursement est initié, sans qu’un Contrat
soit formé entre le Client et le Partenaire. Le Client en est informé dans les
plus brefs délais ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              la Société ou le Partenaire se réservent dans ce dernier cas la possibilité de
              proposer au Client une autre date ou un autre Partenaire.
              </li>
            </p>
          </ul>
          <p className="body mt-16 grey66 bold50">
          Il est rappelé que de manière générale, les Services proposées par les Partenaires
sur la Plateforme sont soumis à la disponibilité de ces derniers. Aucune demande
d’indemnisation ne pourra être formulée en cas de non-disponibilité d’un Partenaire
pour un Service, que cette demande soit adressée au Partenaire ou à la Société.
          </p>
          <p className="body mt-16 grey66 bold50">
          Il est précisé que le Client bénéficie d’une faculté d’annulation de sa demande de
réservation tant que celle-ci n’est pas confirmée par le Partenaire. Cette annulation
de demande doit être effectuée en ligne sur le Compte du Client.
          </p>
          <h5 className="grey500 mt-16 bold600 mt-24">
            Bon récapitulatif de réservation
          </h5>
          <p className="body mt-16 grey66 bold50">
          Lorsque le Contrat est conclu, le Client reçoit un bon récapitulatif du Service réservé.
Ce bon récapitulatif reprend les principales caractéristiques du Service réservé (lieu,
date, heure, point de rendez-vous, nom du Partenaire, nom du Service etc.).
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Client devra remettre le bon récapitulatif au Partenaire au début du Service.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Client reconnaît avoir été informé et accepte qu’un Service réservé puisse devoir
être modifiée et/ou adaptée par le Partenaire pour des motifs imprévisibles ou
évènements indépendants de sa volonté. Le Service réservé pourrait même devoir
être annulé dans les conditions précisées à l’article « Annulation » des présentes.
          </p>
          <h5 className="grey500 mt-16 ">4.2 Paiement des Services réservés</h5>
          <p className="body mt-16 grey66 bold50">
          La Société, qui bénéficie d’un mandat d’encaissement et de facturation de la part du
Partenaire, valide et encaisse au nom et pour le compte du Partenaire le prix du ou
des Service(s) réservé(s).
          </p>
          <p className="body mt-16 grey66 bold50">
          Pour toute réservation d’un montant total supérieur à 200 euros, TWYNY pourra
demander au Client de lui fournir la copie d’une pièce d’identité ainsi qu’un certificat
de domicile avant de valider la demande de réservation.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Site et le Service digital permettent aux Utilisateurs et Clients de prendre
connaissance du prix des Services et de procéder au paiement en Euro.
          </p>
          <h5 className="grey500 mt-16 ">4.3 Modification - Annulation</h5>
          <h5 className="grey500 mt-16 ">Modification du Service</h5>
          <p className="body mt-16 grey66 bold50">
          Le Client pourra demander une modification d’un Contrat et notamment le décalage
de la date prévue d’un Service si une telle modification est possible dans le cadre
des conditions générales de vente du Service et du Partenaire.
          </p>
          <p className="body mt-16 grey66 bold50">
          Toute demande de modification devra être faite par le Client en se connectant sur le
compte Utilisateur sur la Plateforme ou en contactant directement TWYNY à
l’adresse{" "}
            <a href="mailto:support@twyny.com" className="text-decoration-none">
              support@twyny.com
            </a>
            .
          </p>
          <p className="body mt-16 grey66 bold50">
          TWYNY échangera avec le Partenaire concerné afin de tenter de négocier auprès de
          ce dernier, pour le compte du Client, la prise en compte d’une telle modification.
          </p>
          <p className="body mt-16 grey66 bold50">
          Si la demande de modification est acceptée par le Partenaire, un nouveau bon
récapitulatif sera émis et envoyé au Client mentionnant les caractéristiques modifiées
de la réservation. Le cas échéant, TWYNY mettra en place le paiement ou
remboursement découlant de la modification de la réservation pour le compte du
Partenaire.
          </p>
          <p className="body mt-16 grey66 bold50">
          Il est précisé que le Partenaire n’est jamais obligé d’accepter une demande de
modification d’un Contrat. Une telle demande, si elle est acceptée, peut donner lieu à
des frais selon les conditions générales de vente du Service et du Partenaire.
          </p>
          <p className="body mt-16 grey66 bold50">
          Si la demande de modification est refusée, le Client qui souhaite maintenir sa
          demande devra mettre en œuvre le processus d’annulation décrit ci-dessous.
          </p>
          <h5 className="grey500 mt-16 ">Annulation par le Client</h5>
          <p className="body mt-16 grey66 bold50">
          Les modalités d’annulation par le Client, ainsi que les frais en résultant, sont
mentionnées dans la politique d’annulation, la capacité de TWYNY à rembourser le
montant du Service est strictement régi par les dispositions de la politique
d'annulation applicable.
          </p>
          <p className="body mt-16 grey66 bold50">
          La non-présentation ou présence du Client le jour prévu pour la réalisation du
Service, pour le ou lesquels le Service a été réservé et le Contrat conclu, est traitée
comme une annulation de dernière minute par le Client et ne donnera pas lieu à
remboursement.
          </p>
          <h5 className="grey500 mt-16 ">Annulation par le Partenaire</h5>
          <p className="body mt-16 grey66 bold50">
          Le Partenaire peut annuler un Service si des circonstances indépendantes de sa
          volonté rendent impossible la réalisation du Service.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Partenaire informe le Client d’une telle situation dans les meilleurs délais.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le cas échéant le Partenaire peut proposer au Client de décaler la date choisie pour
réaliser le Service. Si le Client refuse cette proposition, les conditions applicables en
cas d’annulation d’un Service par le Partenaire s’appliqueront, et le Client pourra
prétendre à un remboursement intégral du prix du Service, à l’exclusion de toute
indemnité.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le remboursement des sommes versées par le Client pour ledit Service intervient
dans les meilleurs délais à compter de l’information par le Partenaire de cette
annulation.
          </p>
          <p className="body mt-16 grey66 bold50">
          Ce remboursement est réalisé par la Société en sa qualité de mandataire du
          Partenaire.
          </p>
          <h4 className="grey500 mt-24">
            ARTICLE 5 — ÉVALUATION DU PRESTATAIRE
          </h4>
          <p className="body mt-16 grey66 bold50">
          La Société a mis en place un système d’évaluation permettant au Client d’évaluer le
          Partenaire et les Services qu’il propose.
          </p>
          <p className="body mt-16 grey66 bold50">
          Pour publier une évaluation ou un avis concernant un Partenaire ou un Service,
chaque Client doit être une personne majeure, bénéficier d’un compte sur TWYNY et
avoir effectivement réservé puis réalisé un Service avec un Partenaire. L’avis ne peut
être rédigé qu’une fois le Contrat exécuté.
          </p>
          <p className="body mt-16 grey66 bold50">
          La note sera attribuée sur une échelle de 1 à 5.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Client pourra également saisir des commentaires en ligne dans le cadre de cette
évaluation. L’évaluation réalisée par le Client l’est sous sa propre et seule
responsabilité, la Société n’assumant aucune responsabilité à ce titre.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Client s’engage à respecter la réglementation en vigueur et s’engage en
particulier à commenter et évaluer les Services et les Partenaires de manière
objective et à ne pas émettre de propos diffamants, injurieux ou mensongers
concernant les Services ou le Partenaire.
          </p>
          <p className="body mt-16 grey66 bold50">
          Par ailleurs, les évaluations doivent être intelligibles, porter exclusivement sur le
Service évalué et leur contenu texte ne peut contenir des informations personnelles
(telles que nom ou prénom de personnes privées, numéro de téléphone, adresses),
des informations financières, des liens vers d’autres sites web, ainsi que tout contenu
laissant penser à l’existence d’un conflit d’intérêt.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Client s’interdit par ailleurs d’intégrer tous éléments de nature politique, religieuse
          ou à connotation sexuelle dans ses évaluations.
          </p>
          <p className="body mt-16 grey66 bold50">
          TWYNY procède à une modération des évaluations, dont l’objectif est de s’assurer
du respect des présentes Conditions Générales. A ce titre, chaque évaluation peut
être soumise à une modération a priori. La Société se réserve le droit de contacter un
Utilisateur en cas de nécessité de vérification d’une évaluation.
          </p>
          <p className="body mt-16 grey66 bold50">
          Un Utilisateur ou un Partenaire peut demander la modération d'une évaluation en
ligne en écrivant à l'adresse {" "}
            <a href="mailto:support@twyny.com" className="text-decoration-none">
              support@twyny.com
            </a>{" "}
            et en explicitant les motivations de sa demande.
          </p>
          <p className="body mt-16 grey66 bold50">
          La Société se réserve dans ce cadre le droit de supprimer tout commentaire qui ne
respecterait pas les principes rappelés ci-dessus. En cas d’atteinte répétée aux
principes évoqués ci-dessus, et après avoir appliqué les procédures applicables à
ces atteintes, la Société pourra suspendre ou résilier le compte de l’Utilisateur qui se
rendrait coupable de tels manquements répétés.
          </p>
          <p className="body mt-16 grey66 bold50">
            Il est précisé que les Partenaires bénéficient d’un droit de
            réponse, qui devra être envoyée à l’adresse{" "}
            <a href="mailto:support@twyny.com" className="text-decoration-none">
              support@twyny.com
            </a>{" "}
            dans un délai maximal de trois mois suivant la date de publication
            initiale d’une évaluation. TWYNY s’assure de la conformité de la
            réponse avec les présentes Conditions Générales et l’ensemble des
            points mentionnés ci-dessus avant de procéder à sa mise en ligne
          </p>
          <h4 className="grey500 mt-24">ARTICLE 6 — COÛT DU SERVICE</h4>
          <p className="body mt-16 grey66 bold50">
          Le Service est proposé moyennant des frais de protection acheteurs. Le coût est de
5.5% du prix du service réservé pour l’Utilisateur et le Client en sus du paiement des
sommes dues au Partenaire au titre du Contrat.
          </p>
          <h4 className="grey500 mt-24">
            ARTICLE 7 — OBLIGATIONS ET ENGAGEMENTS DE L’UTILISATEUR
          </h4>
          <h5 className="grey500 mt-16 ">7.1 Respect des lois et règlements</h5>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur s’engage à utiliser le Site et le Service digital dans le respect des droits
des tiers et avec respect et courtoisie à l'égard des droits des Partenaires et de la
Société.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur s’engage, lors de la navigation sur le Site et de l’utilisation du Service, à
          respecter la réglementation applicable.
          </p>
          <p className="body mt-16 grey66 bold50">
            L’Utilisateur s’engage notamment à :
          </p>
          <ul>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas utiliser le Site ou le Service digital pour bénéficier de prestations qui
              seraient en infraction avec la réglementation applicable ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas diffamer, injurier ou dénigrer une personne, physique ou morale ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas créer un compte utilisateur avec une identité fictive, ne pas falsifier sa
              propre identité ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas nuire à autrui via l’utilisation du Site ou du Service digital, et
notamment ne pas usurper l’identité d’un tiers et de façon plus générale ne
pas utiliser les données d’un tiers ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas utiliser les coordonnées obtenues via le Site ou le Service digital pour
diffuser des courriers non sollicités ou non autorisés, quelle que soit la forme
de la communication ou sollicitation ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas utiliser les coordonnées obtenues via le Site ou le Service digital pour
diffuser des virus informatiques ou assimilés ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas porter atteinte à la réputation des Partenaires, de la Société ou à
              l’image de la marque TWYNY ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>ne pas perturber ou permettre l’interruption du Site ;</li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas essayer de porter ou porter atteinte aux services fournis par un ou
plusieurs des partenaires de la Société et notamment de l’hébergeur, ce qui
comprend, sans exhaustivité, le fait d'exposer le Site à un virus, de créer une
saturation, d'inonder le serveur ou encore de saturer la messagerie d'e-mails ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas tenter d’accéder ou accéder aux données qui ne sont pas destinées à
l’Utilisateur ou tenter d’entrer ou entrer dans tout ou partie du serveur
hébergeant le Site, dans un espace privé d’un Utilisateur et/ou de tenter
d’accéder ou accéder à tout ou partie des données auxquelles l’Utilisateur
n'est pas autorisé à avoir accès ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas sonder, scruter ou tester la vulnérabilité d’un système ou d'un réseau,
ou enfreindre les mesures de sécurité ou d'authentification du Site ou de tout
ou partie d’un Service ou tenter d’accéder de façon illicite aux réseaux et
systèmes connectés au Site ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              ne pas télécharger sur le Site, afficher, envoyer par courrier électronique ou
transmettre par tout autre moyen tout élément contenant des virus logiciels ou
autres codes, fichiers ou programmes informatiques conçus pour ou ayant
pour objet d’interrompre, de détruire ou de limiter la fonctionnalité de tout
logiciel ou matériel informatique ou de tout équipement de télécommunication.
              </li>
            </p>
          </ul>
          <h5 className="grey500 mt-16 ">
            7.2 Responsabilité et obligations liées à la réservation d’un
            Service
          </h5>
          <p className="body mt-16 grey66 bold50">
          Dans le cadre de la réservation et de l’exécution des Services, le Client s’engage
          notamment à :
          </p>
          <ul>
            <p className="body mt-16 grey66 bold50">
              <li>
              s’assurer de lui-même qu’il répond aux conditions nécessaires, le cas échéant
mentionnées sur la description du Service avant de réserver un Service ; dans
le cas contraire le Partenaire pourra refuser l’accès du Service au Client, sans
possibilité de remboursement ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              s’assurer de l’exactitude des informations fournies dans le cadre de la
réservation d’un Service auprès d’un Partenaire ; dans le cas contraire, le
Partenaire pourra refuser l’accès à un Service ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              respecter strictement les consignes et règles du Partenaire, avant, pendant, et
après l’exécution du Service, en particulier tous les règlements et consignes
permettant d’assurer le déroulé du Service dans des conditions de sécurité
optimales ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              se présenter à l’heure et sur le lieu prévus et mentionnés dans le bon
récapitulatif de réservation, tout retard supérieur à 15 minutes pouvant
entraîner une annulation de la réservation selon les conditions du Partenaire
et du Service concerné et rappelés sur le bon récapitulatif de réservation.
              </li>
            </p>
          </ul>
          <p className="body mt-16 grey66 bold50">
          Il est précisé que tout service exercée en dehors ou en parallèle du cadre du Service
          réservé ne pourra engager la responsabilité du Partenaire ni celle de la Société.
          </p>
          <p className="body mt-16 grey66 bold50">
          Il est également précisé que TWYNY n’a pas les moyens techniques de vérifier qu’un
Client bénéficie de la condition physique, de l’expérience, d’un brevet ou certificat, ou
d’un niveau suffisant pour pratiquer un Service.
          </p>
          <p className="body mt-16 grey66 bold50">
          A ce titre, il est expressément précisé que le Client réserve et participe aux Services
sous sa propre responsabilité, en prenant en compte son niveau, sa condition
physique, son expérience, ses limites, et les risques inhérents liés à la pratique d’une
activité.
          </p>
          <p className="body mt-16 grey66 bold50">
          Dans ce cadre, ni les Partenaires ni la Société ne pourront être mis en cause en cas
          de blessures, accident ou décès lors de la pratique d’une activité.
          </p>
          <h5 className="grey500 mt-16 ">7.3 Garanties</h5>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur garantit la Société en cas de condamnation prononcée contre celle-ci
résultant, directement ou indirectement, de l’utilisation par l’Utilisateur du Site ou du
Service digital.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur s’engage à rembourser à la Société l’intégralité des sommes que celle-ci
aurait été amenée à verser dans une telle situation, que ce soit à la suite du
prononcé d’une décision de justice ou dans le cadre d’une transaction.
          </p>
          <h5 className="grey500 mt-16 ">7.4 Assurance</h5>
          <p className="body mt-16 grey66 bold50">
          Le Client est informé sur l’obligation d’être correctement assuré en responsabilité
civile et assurance en France pour la pratique d’activités. Il est précisé que les
Services proposées sur TWYNY, sauf mentions contraires, ne comprennent pas
d’assurances individuelles.
          </p>
          <p className="body mt-16 grey66 bold50">
          Il appartient au Client de s’assurer que sa couverture assurantielle est suffisante et
          au besoin de contracter une protection adéquate avec l’assureur de son choix.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 8 — CONVENTION DE PREUVE</h4>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur accepte expressément que l’ensemble des données sous forme
électronique, quel que soit leur support notamment les logs de connexion, fichiers
informatiques, identifiants, informations d'horodatage, messages, emails et autres,
émanant du système informatique de la Société et de ses sous-traitants et
partenaires lui soient pleinement opposables.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur s’engage à ne pas contester la recevabilité, la validité et l’opposabilité de
tels éléments de preuve au motif de leur nature dématérialisée et reconnaît que ces
éléments feront foi de la réalité des opérations.
          </p>
          <p className="body mt-16 grey66 bold50">
          Ainsi les éléments considérés constituent des preuves et, s’ils sont produits par la
Société dans une procédure contentieuse ou autre, sont recevables, valables et
opposables entre les parties de la même manière, dans les mêmes conditions et

avec la même force probante que tout document qui serait établi, reçu ou conservé
par écrit papier.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 9 — PROPRIÉTÉ</h4>
          <h5 className="grey500 mt-16">
            9.1 Droits sur le Site et le Service digital
          </h5>
          <p className="body mt-16 grey66 bold50">
          Le Site, le Service digital ainsi que les données qu’ils contiennent sont protégés par
          le droit de la propriété intellectuelle.
          </p>
          <p className="body mt-16 grey66 bold50">
          Ainsi, sauf mention contraire, les droits de propriété intellectuelle sur les documents
et toute donnée de toute nature contenus dans le Site et le Service digital et
notamment sur chacun des éléments composant le Site et le Service digital (images
animées ou non, illustrations, photographies, sons, savoir-faire, architecture, textes,
éléments graphiques, etc.), y compris les logiciels et bases de données sont la
propriété exclusive de la Société et des Partenaires (ci-après les « Eléments
Protégés »).
          </p>
          <p className="body mt-16 grey66 bold50">
          La Société ne concède aucune licence sur tout ou partie des Eléments Protégés ni
          aucun droit autre que celui de consulter le Site et d’utiliser le Service digital.
          </p>
          <p className="body mt-16 grey66 bold50">
          La reproduction de tout ou partie du Site et/ou des Eléments Protégés est autorisée
          aux seules fins d'information pour un usage personnel et privé du Service digital.
          </p>
          <p className="body mt-16 grey66 bold50">
          Toute reproduction et toute utilisation de copies réalisées à d'autres fins, de quelque
manière que ce soit, et sous quelque forme que ce soit, est expressément interdite,
sauf accord préalable et écrit de la Société.
          </p>
          <p className="body mt-16 grey66 bold50">
            Il est également interdit de :
          </p>
          <ul>
            <p className="body mt-16 grey66 bold50">
              <li>
              copier, modifier, créer une œuvre dérivée, assembler, décompiler (à
l'exception des cas prévus par la loi), vendre, attribuer, sous-licencier ou
transférer de quelque manière que ce soit tout droit afférant aux Eléments
Protégés ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              modifier tout ou partie des Eléments Protégés en vue notamment d'obtenir un
accès non autorisé au Service digital et d'accéder au Site par un autre moyen
que l'interface qui est fournie à l’Utilisateur par la Société à cet effet ;
              </li>
            </p>
            <p className="body mt-16 grey66 bold50">
              <li>
              accéder ou utiliser les Eléments Protégés en détournant les finalités, principes
              ou conditions d’utilisation du Site, que ce soit de façon directe ou indirecte.
              </li>
            </p>
          </ul>
          <p className="body mt-16 grey66 bold50">
          En conséquence, toute reproduction et/ou représentation, totale ou partielle du Site,
du Service digital et/ou des Eléments Protégés, sans l’autorisation préalable et écrite
de la Société, est interdite et constitue une contrefaçon sanctionnée notamment par
le Code de la propriété intellectuelle.
          </p>
          <h5 className="grey500 mt-16 ">9.2 Droits sur l’Application</h5>
          <p className="body mt-16 grey66 bold50">
          La Société concède à l’Utilisateur, à titre gratuit, une licence personnelle, non-
          exclusive, non transférable d’utilisation de l’Application, en code objet.
          </p>
          <p className="body mt-16 grey66 bold50">
          Aucun autre droit n’est concédé sur l’Application. La Société se réserve en particulier
le droit de correction et de modification de l’Application, sans pour autant prendre vis-
à-vis de l’Utilisateur aucun engagement à ce titre.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le bénéfice de la présente licence est strictement limité à un usage pour bénéficier
du Service digital et pourra être remis en cause sans préavis par la Société en cas
de non-respect par l’Utilisateur des termes des présentes.
          </p>
          <p className="body mt-16 grey66 bold50">
          Les termes des présentes conditions sont complétés et précisés par les conditions
de licence figurant dans le contrat dans lequel l’utilisateur s’est engagée avec la
Plateforme.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur reconnaît que les conditions de ce contrat l’engagent vis-à-vis de la
Société. L’Utilisateur s’engage dans ce cadre à respecter ces conditions et
engagerait sa responsabilité vis-à-vis de la Société dans l’hypothèse où il n’en
respecterait pas les termes.
          </p>
          <h5 className="grey500 mt-16">
            9.3 Droits sur les signes distinctifs
          </h5>
          <p className="body mt-16 grey66 bold50">
          Toutes les marques, logos et autres signes distinctifs qui apparaissent sur le Site et
le Service digital, y compris les noms de domaine, sont la propriété exclusive de la
Société et de ses partenaires. En particulier, Twyny est une marque déposée.
          </p>
          <p className="body mt-16 grey66 bold50">
          Toute utilisation, de quelque manière que ce soit, de ces marques et/ou logos et/ou
tout autre signe distinctif est soumis à l'autorisation préalable et écrite de la Société
ou des Partenaires ou autres partenaires titulaires des droits concernés.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur reconnaît les droits de la Société et de ses partenaires sur ces signes
distinctifs et s'interdit d'en faire un usage quelconque et plus généralement de porter
atteinte aux droits de propriété intellectuelle de la Société et des partenaires.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur reconnaît que toute atteinte à ces droits constituerait un préjudice pour la
Société et/ou les Partenaires et/ou ses partenaires, notamment en termes d’atteinte
à l’image.
          </p>
          <h5 className="grey500 mt-16">
            9.4 Commentaires et Contenu des Utilisateurs
          </h5>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur cède à la Société tous les droits de propriété intellectuelle nécessaires et
suffisants sur le Contenu pour permettre à la Société de mettre en ligne et diffuser
tout ou partie dudit Contenu sur le Site.
          </p>
          <p className="body mt-16 grey66 bold50">
          Les droits concédés dans ce cadre sont en particulier les droits de reproduction,
représentation, transmission, traduction, diffusion, exploitation et le cas échéant
modification et traduction, sur les médias de toute sorte. Ces droits sont concédés à
titre gratuit, pour le monde entier et pour la durée de protection du Contenu par le

droit de la propriété intellectuelle, et autorisent la mise en ligne au moyen de tous les
procédés techniques connus ou à venir.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur garantit détenir les droits de propriété suffisants sur le Contenu pour
autoriser une telle mise en ligne et porte seul la responsabilité de la conformité légale
du Contenu. L’Utilisateur s’engage dans ce cadre à ce que le Contenu mis en ligne
ne porte pas atteinte aux droits, notamment de propriété intellectuelle, d’un tiers.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur garantit la Société contre toutes réclamations et actions liées à la mise
          en ligne du Contenu dans le cadre du Service.
          </p>
          <h4 className="grey500 mt-24">
            ARTICLE 10 — CONSÉQUENCES EN CAS DE NON-RESPECT DES CONDITIONS
            GÉNÉRALES
          </h4>
          <p className="body mt-16 grey66 bold50">
          La Société se réserve, en cas de non-respect par un Utilisateur de l’une des
obligations mentionnées aux présentes, de suspendre ou exclure l’Utilisateur du
bénéfice du Service digital.
          </p>
          <p className="body mt-16 grey66 bold50">
          Ces possibilités s’entendent sans préjudice des possibles recours en responsabilité
de la Société contre l’Utilisateur.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 11 — MODIFICATIONS</h4>
          <h5 className="grey500 mt-16 ">
            11.1 Modifications du Site et/ou du Service digital
          </h5>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur reconnaît que la Société est libre de faire évoluer le Site et/ou le Service
          digital, à tout moment et à sa seule discrétion.
          </p>
          <p className="body mt-16 grey66 bold50">
          Les modifications qui pourraient être apportées au Site et/ou au Service digital
          relèvent du seul arbitrage de la Société.
          </p>
          <h5 className="grey500 mt-16 ">
            11.2 Modifications des Conditions Générales
          </h5>
          <p className="body mt-16 grey66 bold50">
          La Société se réserve le droit d’adapter ou de modifier à tout moment les présentes
          conditions générales.
          </p>
          <p className="body mt-16 grey66 bold50">
          En cas de modifications substantielles, l’Utilisateur en sera averti par tout moyen utile
          à la discrétion de la Société, comme un affichage à la connexion au Site.
          </p>
          <p className="body mt-16 grey66 bold50">
          Toute utilisation du Service digital postérieurement à cette modification sera
considérée comme valant acceptation des modifications intervenues.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 12 — RESPONSABILITÉ</h4>
          <h5 className="grey500 mt-16">
            12.1 Accès et fonctionnement du Site et du Service digital
          </h5>
          <p className="body mt-16 grey66 bold50">
          La Société est tenue à une obligation de moyens. Elle fournit le Service digital en
          bon professionnel diligent.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur reconnaît que, nonobstant tous les moyens que la Société met en
œuvre, l’Internet et les réseaux télécoms présentent des spécificités techniques qui
impliquent l'impossibilité de garantir (i) le bon fonctionnement du Site et du Service
digital, notamment en termes de continuité ininterrompue de l'accès au Site, de
performances du Site et du Service digital tels que par exemple le temps de réponse
des différentes requêtes et actions soumises et (ii) la sécurité du Site et du Service
digital notamment en termes de présence de virus.
          </p>
          <p className="body mt-16 grey66 bold50">
          En outre, l’Utilisateur est averti et accepte que l’exploitation du Site et du Service
digital nécessite que la Société réalise des interventions techniques, notamment
dans le cadre d’opérations de maintenance. A ce titre, le Site et le Service digital
peuvent être suspendus de manière temporaire, notamment en cas de panne du
système, de maintenance, de réparation ou de mise à jour.
          </p>
          <p className="body mt-16 grey66 bold50">
          La Société ne saurait être tenue pour responsable d'un quelconque dommage que
l’Utilisateur pourrait subir à la suite d'une utilisation du Site ou du Service digital et
notamment de tout dommage résultant de l’indisponibilité du Site ou du Service
digital et notamment les problèmes techniques.
          </p>

          <h5 className="grey500 mt-16">
            12.2 Périmètre de responsabilité de la Société
          </h5>
          <p className="body mt-16 grey66 bold50">
          La Société assure un service digital de mise en relation entre les Clients et les
          Partenaires.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Partenaire est seul responsable vis-à-vis du Client de la bonne exécution des
          Services qu’il propose à la réservation sur le Site.
          </p>
          <p className="body mt-16 grey66 bold50">
          La Société ne saurait en aucune façon être tenue pour responsable du non-respect
total ou partiel d’une obligation et/ou de la mauvaise exécution par un Partenaire
dans le cadre de la réalisation d’un Service.
          </p>
          <p className="body mt-16 grey66 bold50">
          La Société ne peut en conséquence pas voir sa responsabilité engagée en cas de
mauvaise exécution ou d’inexécution, partielle ou totale, de ses obligations par le
Partenaire.
          </p>
          <p className="body mt-16 grey66 bold50">
          La société ne saurait non plus en aucun cas voire sa responsabilité engagée du fait
des agissements d’un Client lors de la réalisation de la Prestation.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Client s’engage à ne pas agir contre la Société en cas de difficulté liée à
          l’exécution, l’inexécution ou la mauvaise exécution d’un Service.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’Utilisateur se porte fort de l’acceptation des présentes conditions générales par les
Clients dont il serait responsable de l’inscription à un Service.
          </p>
          <h5 className="grey500 mt-16">12.3 Limitations de responsabilité</h5>
          <p className="body mt-16 grey66 bold50">
          La responsabilité de la Société ne peut être engagée qu’en cas de faute, prouvée par
l’Utilisateur ou un Client, à ses obligations contractuelles dans l’exécution du Service
digital de mise en relation. La Société ne sera responsable que des seuls dommages
résultant de fautes qui lui sont directement et exclusivement imputables.
          </p>
          <p className="body mt-16 grey66 bold50">
          En cas de responsabilité de la Société envers l’Utilisateur, la Société sera
responsable des dommages directs subis par l’Utilisateur et prouvés par ce dernier
dans la limite, pour toute la durée de la relation contractuelle et pour l’ensemble des
sinistres, d’un montant global correspondant à un maximum de 500 euros.
          </p>
          <p className="body mt-16 grey66 bold50">
          La Société ne pourra encourir aucune responsabilité du fait de dommages indirects.
          </p>
          <p className="body mt-16 grey66 bold50">
          La présente clause est applicable quel que soit le fondement juridique de la
demande, y compris si elle est fondée sur une négligence, une déclaration erronée
ou une inexécution contractuelle.
          </p>
          <p className="body mt-16 grey66 bold50">
          Aucune notification de réclamation ne peut être effectuée par l’une des Parties à
l’encontre de l’autre plus de six (6) mois après la date à laquelle les faits constitutifs
de la réclamation ont été découverts ou auraient dû être découverts.
          </p>
          <p className="body mt-16 grey66 bold50">
          La responsabilité de la Société ne pourra pas être engagée, de manière générale,
dans les cas suivants : (i) fait de l’Utilisateur, Client ou du Partenaire, ou (ii) cas de
force majeure, ou (iii) fait d’un tiers et notamment non fonctionnement,
dysfonctionnement, impossibilité d’accès ou difficultés d’utilisation ou de réception du
réseau Internet ou (iv) tout dommage consécutif et/ou non-consécutif à des services
autres que le Service digital délivré par la Société conformément aux présentes, ou
(v) en raison du contenu, de la nature ou des caractéristiques produits et/ou services
fournis par un Partenaire à un Client.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 13 — RÉCLAMATIONS</h4>
          <p className="body mt-16 grey66 bold50">
          TWYNY se soucie de l’expérience de ses Clients et souhaite proposer une
          expérience de réservation de qualité.
          </p>
          <p className="body mt-16 grey66 bold50">
          Ainsi, en cas de difficulté lors de la réservation d’un Service ou lors de son exécution
          par le Partenaire ou le Client peut :
          </p>
          <p className="body mt-16 grey66 bold50">
            <li>
              envoyer un e-mail à{" "}
              <a
                href="mailto:support@twyny.com"
                className="text-decoration-none"
              >
                support@twyny.com
              </a>{" "}
              ;
            </li>
          </p>
          <p className="body mt-16 grey66 bold50">
          En cas de difficulté avec un Partenaire, TWYNY contactera ce dernier et fera ses
meilleurs efforts afin de tenter de régler la difficulté pour le compte du Client. Dans le
cas où un Client souhaiterait obtenir un remboursement partiel ou total du montant
du Service, un tel remboursement - si validé par le Partenaire - sera effectué
directement par TWYNY au nom et pour le compte du Partenaire.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Client a également bien entendu la possibilité de contacter lui-même le Partenaire
en cas de difficulté, à charge pour le Client, le cas échéant, de faire valoir auprès du
Partenaire une demande de remboursement.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Client peut également utiliser le système d’évaluation de la Plateforme, dans le
          respect des règles édictées à l’Article 6 ci-dessus.
          </p>
          <p className="body mt-16 grey66 bold50">
          Par ailleurs, il est rappelé que si TWYNY prend au sérieux les difficultés rencontrées
par les Clients avec les Partenaires ou dans le cadre de la réalisation des Services,
TWYNY ne saurait en aucune façon être tenue pour responsable du non-respect
total ou partiel d’une obligation et/ou de la mauvaise exécution par un Partenaire
dans le cadre de la réalisation d’un Service.
          </p>
          <h4 className="grey500 mt-24">
            ARTICLE 14 — INFORMATIQUE ET LIBERTÉS
          </h4>
          <p className="body mt-16 grey66 bold50">
          Concernant les droits et obligations liés à l’utilisation et à la protection des données
personnelles, l’Utilisateur est invité à se reporter à la Politique de confidentialité
accessible en ligne sur le Site.
          </p>
          <p className="body mt-16 grey66 bold50">
          Cette Politique de confidentialité fait partie intégrante des présentes conditions
          générales.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 15 — LIENS</h4>
          <p className="body mt-16 grey66 bold50">
          Toute création de liens vers le Site, tout encadrement (framing) du Site, et plus
généralement toute utilisation d'un élément composant le Site, est soumise à
l'autorisation préalable et écrite de la Société qui pourra être révoquée à tout moment
à sa seule discrétion.
          </p>
          <p className="body mt-16 grey66 bold50">
          La Société se réserve le droit de (i) demander la suppression de tout lien vers le Site
qui n'aurait pas été, ou ne serait plus, autorisé et de (ii) demander des dommages et
intérêts en réparation du préjudice subi de ce fait.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le Site peut comporter des liens vers d'autres sites Internet ou d'autres sources
Internet. Dans la mesure où la société ne peut pas contrôler ces sites et ces sources
externes, la Société ne peut être tenue pour responsable de la mise à disposition de
ces sites et sources externes, et ne peut supporter aucune responsabilité quant aux
fonctionnements, contenus, publicités, produits, services ou toute autre information
ou donnée disponible sur ou à partir de ces sites ou sources externes.
          </p>
          <p className="body mt-16 grey66 bold50">
          L’établissement de tels liens n'implique pas que la Société parraine ou recommande
le site lié en question ni que la Société soit affiliée à celui-ci.
          </p>
          <p className="body mt-16 grey66 bold50">
          De plus, la Société ne pourra pas être tenue responsable de tous dommages ou
pertes avérés ou allégués consécutifs ou en relation avec l'utilisation ou le fait d'avoir

fait confiance au contenu, à des biens ou des services disponibles sur ces sites ou
sources externes.
          </p>
          <h4 className="grey500 mt-24">ARTICLE 16 — DISPOSITIONS GÉNÉRALES</h4>
          <p className="body mt-16 grey66 bold50">
          Si une ou plusieurs dispositions des présentes sont tenues pour non valides par une
loi ou un règlement, ou déclarées comme telles par une décision définitive d’une
juridiction compétente, elles seront réputées non écrites et les autres dispositions
des présentes garderont toutes leur force et leur portée.
          </p>
          <p className="body mt-16 grey66 bold50">
          Le fait que l’une des parties n’ait pas exigé l’application d’une clause quelconque,
que ce soit de façon permanente ou temporaire, ne pourra en aucun cas être
considéré comme une renonciation aux droits de cette partie découlant de ladite
clause.
          </p>
          <h4 className="grey500 mt-24">
            ARTICLE 17 — DROIT APPLICABLE - LITIGES
          </h4>
          <p className="body mt-16 grey66 bold50">
          Les présentes conditions générales sont régies par et devront être interprétées selon
les lois françaises.
          </p>
          <p className="body mt-16 grey66 bold50">
          Tout litige relatif à l’interprétation, l’exécution ou la résiliation des présentes est de la
          compétence des juridictions de PARIS.
          </p>
          <p className="body mt-16 grey66 bold50">
          Il est rappelé que les Contrats autonomes conclus entre les Partenaires et les Clients
          seront régis par le droit applicable à chacun des cas d’espèces.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Cgu;
